module.exports = __webpack_public_path__ + "static/img/bf1.149e19b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/bf1.png
// module id = Zfqp
// module chunks = 1